var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('h4', [_vm._v("Rules")]), _c('div', {
    staticClass: "buttons"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-plus",
      "round": ""
    },
    on: {
      "click": _vm.newItem
    }
  }, [_vm._v("New")])], 1)]), _c('Table', {
    attrs: {
      "items": _vm.hubspotRules,
      "columns": _vm.columns,
      "actions": _vm.actions,
      "filterProp": "event_action",
      "loading": _vm.loading.hubspotRules
    }
  }), _c('EditDialog', {
    attrs: {
      "item": _vm.item,
      "isOpen": _vm.showEditDialog,
      "onClose": _vm.onCloseDialog
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }